import React, { memo, useMemo } from 'react';
import { StyleSheet } from 'react-native';

import { Button } from '@/components/ButtonComponent';
import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { getQuickButtonLabel, useQuickAmounts } from '@/feature/quick-amounts/hooks/use-quick-amounts';
import { QuickButton } from '@/feature/quick-amounts/hooks/use-user-quick-amounts-store';
import { withOpacity } from '@/styles/styles';

import { useBetslipStore } from '../../hooks/use-betslip-store';

export const QuickAmountsButtons = memo(
    ({
        handlePressQuickAmount,
        disabled = false,
    }: {
        handlePressQuickAmount: (quickAmount: QuickButton) => void;
        disabled?: boolean;
    }) => {
        const quickAmounts = useQuickAmounts();
        const quickAmountsButtons: QuickButton[] = useMemo(
            () => [...quickAmounts, { id: 'MAX', value: -1 }],
            [quickAmounts]
        );
        const quickAmountsMode = useBetslipStore(state => state.quickAmountsMode);

        return (
            <Row gap={'s8'}>
                {quickAmountsButtons.map(quickAmount => {
                    return (
                        <Button
                            key={quickAmount.id}
                            label={getQuickButtonLabel(quickAmount, quickAmountsMode)}
                            variant={'light'}
                            size={'s'}
                            testID={`quick-amount-${quickAmount.id}`}
                            hierarchy={'secondary'}
                            flex={1}
                            disabled={disabled}
                            onPress={() => handlePressQuickAmount(quickAmount)}
                            style={styles.button}
                            disableTextStyle={styles.disableTextStyle}
                            disableContainerStyle={styles.disableContainerStyle}
                        />
                    );
                })}
            </Row>
        );
    }
);

const styles = StyleSheet.create({
    button: {
        backgroundColor: ds.colorValue.background.neutral.subtle,
    },
    disableTextStyle: {
        color: withOpacity(ds.colorValue.text.primary, 0.15),
    },
    disableContainerStyle: {
        backgroundColor: ds.colorValue.background.transparent.subtle,
    },
});
